module.exports = __webpack_public_path__ + "static/img/inspect-used-car-before-buying.6438d0b.jpg";